/** @format */

import React from "react";
import styles from "./dect.module.scss";
import { useTranslation } from "react-i18next";
import token from "../../../../img/mokupToken.webp";
import cn from "classnames";
import lawPartner2 from "../../../../img/lawpartner2.webp";
import lawPartner3 from "../../../../img/lawpartner3.webp";
import Button from "../../../../components/Button/Button";

const list = [
  "Tradable from Q3 2026",

  "Access to your own plant (via planting site NFT)",

  "We plant, care for and harvest your plant",

  "You preserve the yield of your plant for a lifetime",

  "Cultivation has started",
  "Watch your own plant via live camera",
  "Free site visits",
  "Shop with 50% discount in the DAG Shop",
];

const Dect = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.insured}>
      <div className="container">
        <h2 className={styles.desktop}>{t("German Cannabis Token")}</h2>
        <h2 className={styles.mobile} style={{ textAlign: "center" }}>
          {t("German Cannabis Token")}
        </h2>
        <p className={`${styles.insured__text} ${styles.desktop}`}>
          {t(
            "World's first crypto asset related to cannabis legalization in Germany"
          )}
        </p>
        <div className={cn(styles.insured__right, styles.two)}>
          <div className={styles.desktop}></div>
        </div>
        <div className={styles.insured__inner}>
          <div className={cn(styles.insured__left, styles.one)}>
            <div className={styles.insured__left_token}>
              {/* <div>
                <p className={styles.insured__left_price}>
                  {t("Price per DECT: 2.500€")}
                </p> 
                <Button text={t("Buy Now")} color="green" to="/register" />
              </div> */}
              <picture>
                <source srcSet={token} type="image/webp" />
                <img src={token} alt="token" />
              </picture>
            </div>
            <div className={styles.insured__button}>
              <Button to="/buy" text={t("Secure token now")} color="green" />
            </div>
            {/* <div className={styles.insured__lawpartners}>
              <h3 className={styles.desktop}>
                {t("Advised on supervisory law by:")}
              </h3>
              <div>
                <picture>
                  <source srcSet={lawPartner2} type="image/webp" />
                  <img src={lawPartner2} alt="partner" />
                </picture>
              </div>
            </div> */}
          </div>
          <div
            className={cn(styles.insured__right, styles.two, styles.desktop)}
          >
            <div>
              {/* <h6>
                {t('Your benefits')}:
              </h6> */}
              {list.map((l, i) => (
                <div className={styles.insured__right_list} key={i}>
                  <svg
                    width="28"
                    height="30"
                    viewBox="0 0 28 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.5297 16.8849L24.1512 15.8818C23.288 15.6255 22.4016 15.465 21.5062 15.4021C22.5868 13.695 23.3338 11.78 23.6879 9.7899L24.306 6.32008L21.1054 7.79549C19.8679 8.36589 18.7215 9.08843 17.6883 9.94365C17.4476 7.68451 16.7825 5.47263 15.7298 3.45711L14.0982 0.333252L12.4667 3.45755C11.5357 5.24057 10.9113 7.15224 10.6107 9.13941C10.5702 9.4069 10.5358 9.67482 10.5073 9.94295C9.47425 9.08816 8.32854 8.36606 7.09129 7.79539L3.89063 6.31997L4.50871 9.78979C4.86312 11.78 5.61015 13.6952 6.69041 15.402C5.7949 15.4646 4.90868 15.6256 4.04541 15.8817L0.666748 16.8848L3.42035 19.0842C4.81395 20.1974 6.43599 20.9905 8.15443 21.4166C8.07933 21.5535 8.00866 21.6909 7.94389 21.8278L6.43851 25.0147L9.91399 24.4289C11.0863 24.2312 12.2101 23.7662 13.1801 23.0796L13.1798 29.6666H15.0202V23.0823C15.9893 23.7675 17.1115 24.2316 18.2819 24.4286L21.7576 25.0145L20.2522 21.8276C20.1876 21.6906 20.1167 21.5531 20.0416 21.4164C21.7599 20.9903 23.3817 20.1973 24.7757 19.084L27.5297 16.8849ZM17.0836 19.9387C16.7311 19.9387 18.0352 21.4418 18.5889 22.6138C17.6076 22.4482 16.6977 22.0483 15.9267 21.4648C15.2963 20.9874 14.7595 20.3877 14.3521 19.6928C14.3008 19.6054 14.2072 19.5516 14.1061 19.55H14.1011H14.0964C13.9937 19.55 13.8979 19.6042 13.8458 19.693C13.4382 20.3879 12.9016 20.988 12.2712 21.465C11.5002 22.0485 10.5905 22.4487 9.60895 22.6141C10.1627 21.4418 11.4666 19.9389 11.1141 19.9389C8.76469 19.9389 6.45112 19.1491 4.5698 17.6467C5.55053 17.3554 6.55556 17.2127 7.55401 17.2127C8.69378 17.2127 9.82518 17.3986 10.903 17.7616C10.9156 17.7659 10.9281 17.7678 10.9399 17.7678C11.0327 17.7678 11.0882 17.645 11.0068 17.5764C10.2534 16.9431 9.57243 16.232 8.97395 15.4574C7.639 13.7284 6.71547 11.681 6.32096 9.46715C8.83473 10.6259 10.9017 12.4965 12.3031 14.7957C12.3254 14.832 12.3596 14.848 12.3938 14.848C12.455 14.848 12.5153 14.7966 12.5016 14.7208C11.8749 11.2138 12.4073 7.54842 14.0985 4.30921C15.3326 6.67214 15.9497 9.2627 15.9497 11.8532C15.9497 12.8128 15.8648 13.7722 15.6955 14.7205C15.6819 14.7962 15.7421 14.8477 15.8033 14.8477C15.8374 14.8477 15.8716 14.8319 15.8938 14.7954C17.2953 12.496 19.3623 10.6256 21.8759 9.46683C21.4816 11.6806 20.5583 13.7279 19.2229 15.4571C18.6244 16.2317 17.9435 16.9428 17.1901 17.5761C17.1087 17.6445 17.1641 17.7674 17.257 17.7674C17.2688 17.7674 17.281 17.7653 17.2939 17.7613C18.3717 17.3985 19.5032 17.2124 20.643 17.2124C21.6415 17.2124 22.6463 17.355 23.6273 17.6464C21.7464 19.1486 19.4326 19.9384 17.0835 19.9384L17.0836 19.9387Z"
                      fill="#509C5B"
                    />
                  </svg>
                  <p
                    style={{
                      fontWeight: [1, 2, 3].includes(i) ? "bold" : "normal",
                    }}
                  >
                    {t(l)}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className={cn(styles.insured__right, styles.two, styles.mobile)}>
            <div>
              {list.map((l, i) => (
                <div className={styles.insured__right_list} key={i}>
                  <svg
                    width="28"
                    height="30"
                    viewBox="0 0 28 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.5297 16.8849L24.1512 15.8818C23.288 15.6255 22.4016 15.465 21.5062 15.4021C22.5868 13.695 23.3338 11.78 23.6879 9.7899L24.306 6.32008L21.1054 7.79549C19.8679 8.36589 18.7215 9.08843 17.6883 9.94365C17.4476 7.68451 16.7825 5.47263 15.7298 3.45711L14.0982 0.333252L12.4667 3.45755C11.5357 5.24057 10.9113 7.15224 10.6107 9.13941C10.5702 9.4069 10.5358 9.67482 10.5073 9.94295C9.47425 9.08816 8.32854 8.36606 7.09129 7.79539L3.89063 6.31997L4.50871 9.78979C4.86312 11.78 5.61015 13.6952 6.69041 15.402C5.7949 15.4646 4.90868 15.6256 4.04541 15.8817L0.666748 16.8848L3.42035 19.0842C4.81395 20.1974 6.43599 20.9905 8.15443 21.4166C8.07933 21.5535 8.00866 21.6909 7.94389 21.8278L6.43851 25.0147L9.91399 24.4289C11.0863 24.2312 12.2101 23.7662 13.1801 23.0796L13.1798 29.6666H15.0202V23.0823C15.9893 23.7675 17.1115 24.2316 18.2819 24.4286L21.7576 25.0145L20.2522 21.8276C20.1876 21.6906 20.1167 21.5531 20.0416 21.4164C21.7599 20.9903 23.3817 20.1973 24.7757 19.084L27.5297 16.8849ZM17.0836 19.9387C16.7311 19.9387 18.0352 21.4418 18.5889 22.6138C17.6076 22.4482 16.6977 22.0483 15.9267 21.4648C15.2963 20.9874 14.7595 20.3877 14.3521 19.6928C14.3008 19.6054 14.2072 19.5516 14.1061 19.55H14.1011H14.0964C13.9937 19.55 13.8979 19.6042 13.8458 19.693C13.4382 20.3879 12.9016 20.988 12.2712 21.465C11.5002 22.0485 10.5905 22.4487 9.60895 22.6141C10.1627 21.4418 11.4666 19.9389 11.1141 19.9389C8.76469 19.9389 6.45112 19.1491 4.5698 17.6467C5.55053 17.3554 6.55556 17.2127 7.55401 17.2127C8.69378 17.2127 9.82518 17.3986 10.903 17.7616C10.9156 17.7659 10.9281 17.7678 10.9399 17.7678C11.0327 17.7678 11.0882 17.645 11.0068 17.5764C10.2534 16.9431 9.57243 16.232 8.97395 15.4574C7.639 13.7284 6.71547 11.681 6.32096 9.46715C8.83473 10.6259 10.9017 12.4965 12.3031 14.7957C12.3254 14.832 12.3596 14.848 12.3938 14.848C12.455 14.848 12.5153 14.7966 12.5016 14.7208C11.8749 11.2138 12.4073 7.54842 14.0985 4.30921C15.3326 6.67214 15.9497 9.2627 15.9497 11.8532C15.9497 12.8128 15.8648 13.7722 15.6955 14.7205C15.6819 14.7962 15.7421 14.8477 15.8033 14.8477C15.8374 14.8477 15.8716 14.8319 15.8938 14.7954C17.2953 12.496 19.3623 10.6256 21.8759 9.46683C21.4816 11.6806 20.5583 13.7279 19.2229 15.4571C18.6244 16.2317 17.9435 16.9428 17.1901 17.5761C17.1087 17.6445 17.1641 17.7674 17.257 17.7674C17.2688 17.7674 17.281 17.7653 17.2939 17.7613C18.3717 17.3985 19.5032 17.2124 20.643 17.2124C21.6415 17.2124 22.6463 17.355 23.6273 17.6464C21.7464 19.1486 19.4326 19.9384 17.0835 19.9384L17.0836 19.9387Z"
                      fill="#509C5B"
                    />
                  </svg>
                  <p
                    style={{
                      fontWeight: [1, 2, 3].includes(i) ? "bold" : "normal",
                    }}
                  >
                    {t(l)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dect;
